import React, { Component } from "react";
import { connect } from "react-redux";
import SecurityModal from "../../pages/Components/SecurityModal/SecurityModal";
import {
    Card,
    CardContent,
    Button,
    Typography,
    TextField,
    Select,
    Grid,
    MenuItem,
} from "@material-ui/core";

import { selectReport, canUpdate } from "./selectors";
import { getReport, setReport, getStandaloneReport } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";
import { StyledHeader } from "../../styles";
import PrintIcon from "@material-ui/icons/Print";
import data from "./data.json";
import MapContainer from "../MapContainer";

import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";
import "../reports.css";

import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

class NonConformance extends Component {
    constructor(props) {
        super(props);
        let edit = props.location.pathname.split("/");
        if (props.match.params.subject_name === "reports") {
            this.state = {
                imageModal: false,
                selectedImg: false,
                report: false,
                editing: edit[1] === "report-view" ? false : true,
                title: document.title,
                reportType: edit[4].replace(/-/g, "_"),
                checks: data,
            };

            props.getStandaloneReport(
                props.match.params.uid,
                props.match.params.subject_name.replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                edit[4].replace(/-/g, "_")
            );
        } else {
            this.state = {
                imageModal: false,
                selectedImg: false,
                report: false,
                editing: edit[1] === "report-view" ? false : true,
                title: document.title,
                reportType: edit[7].replace(/-/g, "_"),
                checks: data,
            };
            props.getReport(
                props.match.params.uid,
                props.match.params.subject_name.replace(/-/g, "_"),
                edit[3],
                edit[4].replace(/-/g, "_"),
                edit[5].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":"),
                edit[7].replace(/-/g, "_")
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderTick = (key, value = false) => {
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === undefined
                            ? false
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                    style={{ minWidth: "100%" }}
                >
                    <MenuItem value={"Okay"}>Okay</MenuItem>
                    <MenuItem value={"Fault"}>Fault</MenuItem>
                    <MenuItem value={"Not checked"}>Not Checked</MenuItem>
                </Select>
            );
        } else {
            return value;
        }
    };

    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        let ref = "";
        return attachedPhotos.map((photo, i) => {
            if (photo.signature_url.includes("https:") === false) {
                ref = "data:image/png;base64," + photo.signature_url;
            }
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.signature_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.signature_timestamp}
                    </div>
                    {photo.signature_url.includes("https:") ? (
                        <div
                            style={cellStyle(
                                photoRow + 1,
                                photoCell,
                                photoRow + 1,
                                photoCell + 2
                            )}
                        >
                            <img
                                src={photo.signature_url}
                                alt="Site "
                                // onClick={() => {
                                //     this.setState({
                                //         selectedPhoto: photo.signature_url,
                                //         imageModal: true,
                                //     });
                                // }}
                                style={{
                                    width: 300,
                                    height: "170px",
                                    margin: "auto",
                                    // cursor: "pointer",
                                }}
                            />
                        </div>
                    ) : (
                        <div
                            style={cellStyle(
                                photoRow + 1,
                                photoCell,
                                photoRow + 1,
                                photoCell + 2
                            )}
                        >
                            <img
                                src={ref}
                                alt="Site "
                                // onClick={() => {
                                //     this.setState({
                                //         selectedPhoto: ref,
                                //         imageModal: true,
                                //     });
                                // }}
                                style={{
                                    width: 300,
                                    height: "170px",
                                    margin: "auto",
                                    // cursor: "pointer",
                                }}
                            />
                        </div>
                    )}
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    render() {
        //let report = this.props.report === false ? false : this.props.report;

        let gstyle = gridStyle;
        let cstyle = cellStyle;
        let color = this.props.color;

        const { editing, report, selectedImg } = this.state;
        return editing && !this.props.canUpdate ? (
            <SecurityModal
                errType={"Update"}
                errPage={"Block Vehicle Check Report"}
                history={this.props.history}
            />
        ) : (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>
                        Garda Notification Report
                        <ReactToPrint
                            onBeforePrint={() => {
                                setTimeout(undefined, 2000);
                                document.title =
                                    " Garda Notification - " +
                                    this.props.match.params.report_id
                                        .replace(/_/g, " ")
                                        .replace(/\./g, ":");
                            }}
                            onAfterPrint={() => {
                                document.title = this.state.title;
                            }}
                            trigger={() => (
                                <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                    }}
                                />
                            )}
                            content={() => this.componentRef}
                        />
                    </Typography>
                </StyledHeader>
                <CardContent>
                    {report && (
                        <>
                            <div ref={(el) => (this.componentRef = el)}>
                                {this.props.header && <this.props.header />}
                                <div
                                    className="imgDiv"
                                    style={{
                                        float: "left",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Typography variant="h5">
                                        Garda Notification Report
                                    </Typography>
                                </div>
                                <Grid container spacing={8}>
                                    <Grid item xs={6}>
                                        <div
                                            style={gstyle(10, 13)}
                                            ref={(ref) => (this.infoDiv = ref)}
                                        >
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Report Details</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 13)}>
                                                <b>
                                                    The Road Authority
                                                    of/Contractor:
                                                </b>&nbsp; {report.road_authority
                                                    ? report.road_authority
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(3, 1, 3, 13)}>
                                                <b>Hereby Notifies:</b>&nbsp; {report.garda_station
                                                    ? report.garda_station
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(4, 1, 4, 7)}>
                                                <b>Stop-Go Boards:</b>&nbsp;   {report.stop_go_boards
                                                    ? report.stop_go_boards
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(4, 7, 4, 13)}>
                                                <b>Temporary Traffic Lights:</b>&nbsp;  {report.temp_traffic_lights
                                                    ? report.temp_traffic_lights
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(5, 1, 5, 13)}>
                                                <b>Road Closure</b>&nbsp;  {report.road_closure
                                                    ? report.road_closure
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(6, 1, 6, 7)}>
                                                <b>Name:</b>&nbsp;   {report.user_name
                                                    ? report.user_name
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(6, 7, 6, 13)}>
                                                <b>Email:</b>&nbsp;     {report.user_email
                                                    ? report.user_email
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(7, 1, 7, 7)}>
                                                <b>Start Date:</b>&nbsp; {report.start_date
                                                    ? report.start_date
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(7, 7, 7, 13)}>
                                                <b>End Date:</b>&nbsp;   {report.end_date
                                                    ? report.end_date
                                                    : "N/A"}
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <div
                                            style={{
                                                float: "left",
                                                marginLeft: "5%",
                                                width: "95%",
                                                zIndex: "500",
                                            }}
                                        >
                                            <MapContainer
                                                lat={+report.location_lat}
                                                long={+report.location_lon}
                                            />
                                        </div>
                                    </Grid>
                                    {/* <Grid item sm={12} md={6} lg={6}>
                                        <div
                                            style={gstyle(10, 13)}
                                            ref={(ref) => (this.infoDiv = ref)}
                                        >
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Additional Requirement</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 13)}>
                                                <b>Name:</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    6,
                                                    2,
                                                    13,
                                                    true
                                                )}
                                            >
                                                {report.user_name
                                                    ? report.user_name
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(3, 1, 3, 13)}>
                                                <b>Email:</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    3,
                                                    6,
                                                    3,
                                                    13,
                                                    true
                                                )}
                                            >
                                                {report.user_email
                                                    ? report.user_email
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(4, 1, 4, 7)}>
                                                <b>Start Date:</b>
                                            </div>
                                            <div
                                                style={cstyle(4, 5, 4, 7, true)}
                                            >
                                                {report.start_date
                                                    ? report.start_date
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(4, 7, 4, 13)}>
                                                <b>End Date:</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    4,
                                                    10,
                                                    4,
                                                    13,
                                                    true
                                                )}
                                            >
                                                {report.end_date
                                                    ? report.end_date
                                                    : "N/A"}
                                            </div>
                                        </div>
                                    </Grid> */}
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <div style={gstyle(10, 13, null)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Location</b>
                                            </div>
                                            <div
                                                style={cstyle(
                                                    2,
                                                    1,
                                                    3,
                                                    13,
                                                    true
                                                )}
                                            >
                                                <img
                                                    style={{ width: "372px", marginLeft:"33%" }}
                                                    src={
                                                        report.map_url !== ""
                                                            ? report.map_url
                                                            : noImg
                                                    }
                                                    onClick={() => {
                                                        this.setState({
                                                            imageModal: true,
                                                            selectedImg:
                                                                report.map_url,
                                                        });
                                                    }}
                                                    alt={report.map_url}
                                                />
                                            </div>
                                            <div style={cstyle(3, 1, 3, 7)}>
                                                <b>Road:</b>&nbsp;   {report.road_name
                                                    ? report.road_name
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(3, 7, 3, 13)}>
                                                <b>Observations:</b>&nbsp;  {report.return_email
                                                    ? report.return_email
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(4, 1, 4, 7)}>
                                                <b
                                                    style={{
                                                        color:
                                                            "rgb(114, 181, 102)",
                                                    }}
                                                >
                                                    From A Point:
                                                </b>&nbsp; {report.from_point
                                                    ? report.from_point
                                                    : "N/A"}
                                            </div>
                                            {/* <div
                                                style={{
                                                    ...cstyle(4, 4, 4, 7, true),
                                                    fontWeight: "bolder",
                                                }}
                                            >
                                                {report.from_point
                                                    ? report.from_point
                                                    : "N/A"}
                                            </div> */}
                                            <div style={cstyle(4, 7, 4, 13)}>
                                                <b style={{ color: "red" }}>
                                                    To A Point:
                                                </b>&nbsp;  {report.to_point
                                                    ? report.to_point
                                                    : "N/A"}
                                            </div>
                                            {/* <div
                                                style={{
                                                    ...cstyle(
                                                        4,
                                                        10,
                                                        4,
                                                        13,
                                                        true
                                                    ),
                                                    fontWeight: "bolder",
                                                }}
                                            >
                                                {report.to_point
                                                    ? report.to_point
                                                    : "N/A"}
                                            </div> */}
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <div style={gstyle(4, 9, null, color)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    1,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Attached Signatures</b>
                                            </div>
                                            {report.attached_signatures &&
                                                this.renderPhotos(
                                                    report.attached_signatures
                                                )}
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </>
                    )}
                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Additional Notes Image</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        selectedImg === undefined ||
                                        selectedImg === null ||
                                        selectedImg === ""
                                            ? noImg
                                            : selectedImg
                                    }
                                    alt="Site"
                                    style={{ width: "461px", height: "400px" }}
                                />
                                {selectedImg === "" ?
                                    <p style={{textAlign:"center", fontSize:"26px", color:"#EF5350"}}>No Location Image</p>
                                    :
                                    ""
                                }
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: false,
                                            imageModal: false,
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store), canUpdate: canUpdate(store) };
    },
    { getReport, setReport, getStandaloneReport }
)(NonConformance);
